import React, { Component } from "react";
import "./SelecionarFilial.scss";
import logo from "../../../assets/originar-sustentabilidade.png";
import VersionService from "../../../services/VersionService";
import UsuarioService from "../../../services/UsuarioService";
import {
  Container,
  Footer,
  Header,
  Main,
  Form,
  Layout,
  Button,
  Select,
  Loading,
} from "cria-ui-react";
import { Dropdown } from "element-react";
import "element-theme-default";
import { isLogin, clearAllAuthCookies } from "../../../utils";
import { Redirect } from "react-router-dom";
import * as UsuarioActions from "../../../store/actions/usuarioActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ArraysHelpers from "../../../utils/helpers/Array";
import { BASE_URL } from "../../../services/api";

const mapStateToProps = (state) => ({
  dadosUsuario: state.usuarioState.dadosUsuario,
  permissoes: state.usuarioState.permissoes,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(Object.assign({}, UsuarioActions), dispatch);

class SelecionarFilial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      version: null,
      selectedData: [],
      isLogin: isLogin(),
      loading: false,
      form: {
        empresa: "",
        regional: "",
        filial: "",
      },
    };
  }

  componentDidMount() {
    this.getVersion();
    this.fetchFiliais();
  }

  fetchFiliais() {
    this.setState({ loading: true });
    UsuarioService.getTenants(this.props.dadosUsuario.idUsuario)
      .then((response) => {
        this.props.setTodasEmpresas(response.data)
        this.setState({
          selectedData: response.data,
        });
      })
      .catch((error) => {
        Notification.warning({
          title: "Selecionar Empresa",
          message:
            "Ocorreu um erro ao buscar as empresas filiadas à esse usuário",
          duration: 6000,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  getVersion() {
    const { version } = this.state;
    if (!version)
      VersionService.getVersion().then(({ data }) => {
        this.setState({ version: data.version });
      });
  }

  handleLogout = () => {
    clearAllAuthCookies();
    localStorage.clear();
    this.setState({ isLogin: false });
    window.location.href = `${BASE_URL}login`;
  };

  handleCommand(command) {
    switch (command) {
      case "Conta":
        console.log(command);
        break;
      case "Configuracoes":
        console.log(command);
        break;
      case "Sair":
        this.handleLogout();
        break;
      default:
        break;
    }
  }

  handleSubmit() {
    this.props.history.push('/painel-modulos');
  }

  onSelectEmpresa(key, value) {
    this.setState({
      form: {
        empresa: value,
        regional: "",
        filial: "",
      },
    });
    this.props.setEmpresa(value);
  }

  onSelectRegional(key, value) {
    this.setState({
      form: {
        ...this.state.form,
        regional: value,
        filial: "",
      },
    });
    this.props.setRegional(value);
    this.props.setFilial(-1);
  }

  onSelectFilial(key, value) {
    this.setState({
      form: Object.assign({}, this.state.form, { [key]: value }),
    });
    this.props.setFilial(value);
  }

  getRegionais() {
    const { selectedData, form } = this.state;
    if (!form.empresa || !ArraysHelpers.checkArray(selectedData)) return [];
    const empresa = selectedData.find((item) => item.tenant.id === form.empresa);
    return empresa ? empresa.regionais : [];
  }

  getFiliais() {
    const regionais = this.getRegionais();
    if (!this.state.form.regional || !ArraysHelpers.checkArray(regionais)) return [];
    const regionalItem = regionais.find(({ regional }) => regional.id === this.state.form.regional);
    return regionalItem ? regionalItem.filiais : [];
  }

  render() {
    const { version, selectedData } = this.state;
    const { dadosUsuario } = this.props;
    const regionais = this.getRegionais();
    const filiais = this.getFiliais();

    return (
        <div className="container-filial">
          <Loading loading={this.state.loading} text="Buscando as regionais e as filiais">
            <Header>
              <div className="cd-header--content">
                <img src={logo} className="logo" alt="Logotipo Originar" />
                <div className="left-content">
                  <div id="user">
                    <i className="user--icon mdi mdi-account-circle" />
                    <Dropdown
                        trigger="click"
                        onCommand={this.handleCommand.bind(this)}
                        menu={
                          <Dropdown.Menu>
                            <Dropdown.Item command="Conta">
                              <i className="icon-item mdi mdi-account-circle" />
                              Minha conta
                            </Dropdown.Item>
                            <Dropdown.Item command="Configuracoes">
                              <i className="icon-item mdi mdi-settings" />
                              Configurações
                            </Dropdown.Item>
                            <Dropdown.Item divided command="Sair">
                              <i className="icon-item mdi mdi-logout" />
                              Sair
                              {!this.state.isLogin && (
                                  <Redirect to="/login" />
                              )}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        }
                    >
                    <span className="el-dropdown-link">
                      <span className="user--name">{dadosUsuario.nome}</span>
                      <i className="el-icon-caret-bottom el-icon--right"></i>
                    </span>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </Header>

            <Container direction="vertical">
              <Main>
                <div className="cd-main--content">
                  <Layout.Row className="form-filial">
                    <Layout.Row xs={24} sm={24} md={12}>
                      <p className="title-form">
                        Olá,
                        {dadosUsuario != null
                            ? " " + dadosUsuario.nome.split(" ")[0]
                            : null}
                      </p>
                    </Layout.Row>
                    <Form
                        ref="form"
                        labelPosition="top"
                        className="form-content"
                        model={this.state.form}
                    >
                      <Form.Item label="Empresa" prop="empresa">
                        <Layout.Row xs={24} sm={24} md={12}>
                          <Select
                              id="selecionar-empresa"
                              value={this.state.form.empresa}
                              placeholder="Selecione uma empresa"
                              onSelect={this.onSelectEmpresa.bind(this, "empresa")}
                          >
                            {ArraysHelpers.checkArray(selectedData) &&
                                selectedData.map((item) => (
                                    <Select.Option
                                        label={item.tenant.nome}
                                        value={item.tenant.id}
                                        key={item.tenant.id}
                                    />
                                ))}
                          </Select>
                        </Layout.Row>
                      </Form.Item>

                      <Form.Item label="Regional" prop="regional">
                        <Layout.Row xs={24} sm={24} md={12}>
                          <Select
                              id="selecionar-regional"
                              value={this.state.form.regional}
                              placeholder="Selecione uma regional"
                              disabled={this.state.form.empresa === ""}
                              onSelect={this.onSelectRegional.bind(this, "regional")}
                          >
                            {ArraysHelpers.checkArray(regionais) &&
                                regionais.map(({ regional }) => (
                                    <Select.Option
                                        label={regional.nome}
                                        value={regional.id}
                                        key={regional.id}
                                    />
                                ))}
                          </Select>
                        </Layout.Row>
                      </Form.Item>

                      <Form.Item label="Filial" prop="filial">
                        <Layout.Row xs={24} sm={24} md={12}>
                          <Select
                              id="selecionar-filial"
                              value={this.state.form.filial}
                              placeholder={
                                this.state.form.regional === -1
                                    ? "TODAS"
                                    : "Selecione uma filial"
                              }
                              disabled={
                                  this.state.form.regional === "" ||
                                  this.state.form.regional === -1
                              }
                              onSelect={this.onSelectFilial.bind(this, "filial")}
                          >
                            {ArraysHelpers.checkArray(filiais) &&
                                filiais.map((filial) => (
                                    <Select.Option
                                        label={filial.nome}
                                        value={filial.id}
                                        key={filial.id}
                                    />
                                ))}
                          </Select>
                        </Layout.Row>
                      </Form.Item>

                      <Layout.Row xs={24} sm={24} md={12}>
                        <Form.Item>
                          <Button
                              className="btn-confirmar"
                              type="primary"
                              onClick={this.handleSubmit.bind(this)}
                              disabled={
                                  this.state.form.filial === "" &&
                                  this.state.form.regional !== -1
                              }
                          >
                            Confirmar
                          </Button>
                        </Form.Item>
                      </Layout.Row>
                    </Form>
                  </Layout.Row>
                </div>
                <Footer className={"version"}>
                  © {new Date().getFullYear()} - Portal Segurança
                  {version && <div className="version-number">{version}</div>}
                </Footer>
              </Main>
            </Container>
          </Loading>
        </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelecionarFilial);